var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('div'):_c('img',{class:{ disabled: _vm.disabled },attrs:{"src":_vm.currentSrc,"alt":_vm.alt},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }